import React, { createContext, useContext, useState, useEffect } from "react";

interface RolesContextType {
  roles: string[];
  isLoading: boolean;
}

const RolesContext = createContext<RolesContextType | undefined>(undefined);

const staticRoles = ["organizationadmin", "sales", "developers", "support"];
const dummyApiRoles = ["marketing", "finance", "hr"];

const fetchRoles = async (): Promise<string[]> => {
  try {
     const response = await new Promise<string[]>((resolve) =>
      setTimeout(() => resolve(dummyApiRoles), 500)
    );
    return response;
  } catch (error) {
    console.error("Error fetching roles:", error);
    return dummyApiRoles;
  }
};

export const RolesProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [roles, setRoles] = useState<string[]>(staticRoles);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchRoles().then((dynamicRoles) => {
       const allRoles = [...staticRoles];
      dynamicRoles.forEach((role) => {
        const normalizedRole = role.toLowerCase();
        if (!allRoles.includes(normalizedRole)) {
          allRoles.push(normalizedRole);
        }
      });
      allRoles.sort();  
      setRoles(allRoles);
      setIsLoading(false);
    });
  }, []);

  return (
    <RolesContext.Provider value={{ roles, isLoading }}>
      {children}
    </RolesContext.Provider>
  );
};

export const useRoles = () => {
  const context = useContext(RolesContext);
  if (!context) {
    throw new Error("useRoles must be used within a RolesProvider");
  }
  return context;
};